export default [{
    "name": "1899 Hoffenheim",
    "country": "Germany",
    "logo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-football-teams/1899_Hoffenheim_Germany.png",
    "websiteURL": "#"
  },
  {
    "name": "AC Milan",
    "country": "Italy",
    "logo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-football-teams/AC_Milan_Italy.png"
  },
  {
    "name": "Inter Milan",
    "country": "Italy",
    "logo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-football-teams/Inter_Milan_Italy.png"
  },
  {
    "name": "AC Spartans SC",
    "country": "Ghana",
    "logo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-football-teams/AC_Spartans_SC_Ghana.png"
  },
  {
    "name": "AEK Athens",
    "country": "Greece",
    "logo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-football-teams/AEK_Athens_Greece.png"
  },
  {
    "name": "AEK Larnaca FC",
    "country": "Cyprus",
    "logo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-football-teams/AEK_Larnaca_FC_Cyprus.png"
  },
  {
    "name": "AFC Bournemouth",
    "country": "England",
    "logo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-football-teams/AFC_Bournemouth_England.png"
  },
  {
    "name": "AFC Fiorentina",
    "country": "Italy",
    "logo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-football-teams/AFC_Fiorentina_Italy.png"
  },
  {
    "name": "APOEL FC",
    "country": "Cyprus",
    "logo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-football-teams/APOEL_FC_Cyprus.png"
  },
  {
    "name": "AS Roma",
    "country": "Italy",
    "logo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-football-teams/AS_Roma_Italy.png"
  },
  {
    "name": "AZ Alkmaar",
    "country": "Netherlands",
    "logo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-football-teams/AZ_Alkmaar_Netherlands.png"
  },
  {
    "name": "Aalborg BK",
    "country": "Denmark",
    "logo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-football-teams/Aalborg_BK_Denmark.png"
  },
  {
    "name": "Ajax",
    "country": "Netherlands",
    "logo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-football-teams/Ajax_Netherlands.png"
  },
  {
    "name": "Akatsi All stars FC",
    "country": "Ghana",
    "logo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-football-teams/Akatsi_All_stars_FC_Ghana.png"
  },
  {
    "name": "Al Ahly SC",
    "country": "Egypt",
    "logo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-football-teams/Al_Ahly_SC_Egypt.png"
  },
  {
    "name": "Al Hilal Omdurman",
    "country": "Sudan",
    "logo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-football-teams/Al_Hilal_Omdurman_Sudan.png"
  },
  {
    "name": "Alianza FC",
    "country": "El Salvador",
    "logo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-football-teams/Alianza_FC_El_Salvador.png"
  },
  {
    "name": "Apollon Limassol FC",
    "country": "Cyprus",
    "logo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-football-teams/Apollon_Limassol_FC_Cyprus.png"
  },
  {
    "name": "Astana",
    "country": "Kazakhstan",
    "logo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-football-teams/Astana_Kazakhstan.png"
  },
  {
    "name": "Asteras Tripolis",
    "country": "Greece",
    "logo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-football-teams/Asteras_Tripolis_Greece.png"
  },
  {
    "name": "Atalanta",
    "country": "Italy",
    "logo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-football-teams/Atalanta_Italy.png"
  },
  {
    "name": "Athletic Bilbao",
    "country": "Spain",
    "logo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-football-teams/Athletic_Bilbao_Spain.png"
  },
  {
    "name": "Atletico Madrid",
    "country": "Spain",
    "logo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-football-teams/Atletico_Madrid_Spain.png"
  },
  {
    "name": "Atromitos Athens",
    "country": "Greece",
    "logo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-football-teams/Atromitos_Athens_Greece.png"
  },
  {
    "name": "BAK",
    "country": "Hungary",
    "logo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-football-teams/BAK_Hungary.png"
  },
  {
    "name": "Barcelona",
    "country": "Spain",
    "logo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-football-teams/Barcelona_Spain.png"
  },
  {
    "name": "Bayer 04 Leverkusen",
    "country": "Germany",
    "logo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-football-teams/Bayer_04_Leverkusen_Germany.png"
  },
  {
    "country": "Germany",
    "name": "Bayern Munich",
    "logo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-football-teams/Bayern_Munich_Germany.png"
  },
  {
    "name": "Benfica",
    "country": "Portugal",
    "logo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-football-teams/Benfica_Portugal.png"
  },
  {
    "name": "Bofoakwa Tano FC",
    "country": "Ghana",
    "logo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-football-teams/Bofoakwa_Tano_FC_Ghana.png"
  },
  {
    "name": "Borussia Dortmund",
    "country": "Germany",
    "logo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-football-teams/Borussia_Dortmund_Germany.png"
  },
  {
    "name": "Borussia Monchengladbach",
    "country": "Germany",
    "logo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-football-teams/Borussia_Monchengladbach_Germany.png"
  },
  {
    "name": "Brighton",
    "country": "England",
    "logo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-football-teams/Brighton_England.png"
  },
  {
    "name": "Bulawayo Chiefs FC",
    "country": "Zimbabwe",
    "logo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-football-teams/Bulawayo_Chiefs_FC_Zimbabwe.png"
  },
  {
    "name": "CFR Cluj",
    "country": "Romania",
    "logo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-football-teams/CFR_Cluj_Romania.png"
  },
  {
    "name": "Caps United",
    "country": "Zimbabwe",
    "logo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-football-teams/Caps_United_Zimbabwe.png"
  },
  {
    "name": "Celtic",
    "country": "Scotland",
    "logo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-football-teams/Celtic_Scotland.png"
  },
  {
    "country": "USA",
    "name": "Charlotte",
    "logo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-football-teams/Charlotte_USA.png"
  },
  {
    "name": "Chelsea",
    "country": "England",
    "logo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-football-teams/Chelsea_England.png"
  },
  {
    "name": "Chicken Inn FC",
    "country": "Zimbabwe",
    "logo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-football-teams/Chicken_Inn_FC_Zimbabwe.png"
  },
  {
    "name": "Coritiba Foot Ball Club",
    "country": "Brazil",
    "logo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-football-teams/Coritiba_Foot_Ball_Club_Brazil.png"
  },
  {
    "name": "Cork City",
    "country": "Ireland",
    "logo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-football-teams/Cork_City_Ireland.png"
  },
  {
    "country": "USA",
    "name": "DC United",
    "logo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-football-teams/DC_United_USA.png"
  },
  {
    "name": "Tatung FC",
    "country": "Taiwan",
    "logo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-football-teams/Datong_Taiwan.png"
  },
  {
    "name": "Dundalk",
    "country": "Ireland",
    "logo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-football-teams/Dundalk_Ireland.png"
  },
  {
    "country": "Scotland",
    "name": "Dundfermline",
    "logo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-football-teams/Dundfermline_Scotland.png"
  },
  {
    "name": "EB Streymur",
    "country": "Faroe Islands",
    "logo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-football-teams/EB_Streymur_Faroe_Islands.png"
  },
  {
    "name": "Enyimba FC",
    "country": "Nigeria",
    "logo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-football-teams/Enyimba_FC_Nigeria.png"
  },
  {
    "name": "Everton FC",
    "country": "England",
    "logo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-football-teams/Everton_FC_England.png"
  },
  {
    "name": "FA Selangor",
    "country": "Malaysia",
    "logo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-football-teams/FA_Selangor_Malaysia.png"
  },
  {
    "name": "FC Basel 1893",
    "country": "Switzerland",
    "logo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-football-teams/FC_Basel_1893_Switzerland.png"
  },
  {
    "country": "USA",
    "name": "FC Dallas",
    "logo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-football-teams/FC_Dallas_USA.png"
  },
  {
    "name": "FC Lori",
    "country": "Armenia",
    "logo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-football-teams/FC_Lori_Armenia.png"
  },
  {
    "name": "FC Santa Coloma",
    "country": "Andora",
    "logo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-football-teams/FC_Santa_Coloma_Andora.png"
  },
  {
    "name": "FC Slovan Liberec",
    "country": "Czech Republic",
    "logo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-football-teams/FC_Slovan_Liberec_Czech_Republic.png"
  },
  {
    "name": "FC Zenit",
    "country": "Russia",
    "logo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-football-teams/FC_Zenit_Russia.png"
  },
  {
    "name": "FC Zurich",
    "country": "Switzerland",
    "logo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-football-teams/FC_Zurich_Switzerland.png"
  },
  {
    "name": "FK Jelgava",
    "country": "Lithuania",
    "logo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-football-teams/FK_Jelgava_Lithuania.png"
  },
  {
    "name": "FK Sarajevo",
    "country": "Bosnia-Herzegovina",
    "logo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-football-teams/FK_Sarajevo_Bosnia_Herzegovina.png"
  },
  {
    "name": "FK Vardar",
    "country": "Macedonia",
    "logo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-football-teams/FK_Vardar_Macedonia.png"
  },
  {
    "name": "FK Voždovac",
    "country": "Serbia",
    "logo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-football-teams/FK_Voz%CC%8Cdovac_Serbia.png"
  },
  {
    "country": "Scotland",
    "name": "Falkirk FC",
    "logo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-football-teams/Falkirk_FC_Scotland.png"
  },
  {
    "name": "Fehervar",
    "country": "Hungary",
    "logo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-football-teams/Fehervar_Hungary.png"
  },
  {
    "name": "Fenerbahce",
    "country": "Turkey",
    "logo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-football-teams/Fenerbahce_Turkey.png"
  },
  {
    "name": "Ferencvaros",
    "country": "Hungary",
    "logo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-football-teams/Ferencvaros_Hungary.png"
  },
  {
    "name": "Fulham FC",
    "country": "England",
    "logo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-football-teams/Fulham_FC_England.png"
  },
  {
    "name": "GFK Osogovo",
    "country": "Macedonia",
    "logo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-football-teams/GFK_Osogovo_Macedonia.png"
  },
  {
    "name": "GNK Dinamo",
    "country": "Croatia",
    "logo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-football-teams/GNK_Dinamo_Croatia.png"
  },
  {
    "name": "Taipower",
    "country": "Taiwan",
    "logo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-football-teams/Taipower_Taiwan.png"
  },
  {
    "name": "Genk",
    "country": "Belgium",
    "logo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-football-teams/Genk_Belgium.png"
  },
  {
    "name": "Gokulam Kerala FC",
    "country": "India",
    "logo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-football-teams/Gokulam_Kerala_FC_India.png"
  },
  {
    "name": "Gremio",
    "country": "Brazil",
    "logo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-football-teams/Gremio_Brazil.png"
  },
  {
    "name": "HNK Hajduk Split",
    "country": "Croatia",
    "logo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-football-teams/HNK_Hajduk_Split_Croatia.png"
  },
  {
    "name": "Hackney Wick FC",
    "country": "England",
    "logo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-football-teams/Hackney_Wick_FC_England.png"
  },
  {
    "name": "Hang Yuan FC",
    "country": "Taiwan",
    "logo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-football-teams/Hangyuan_FC_Taiwan.png"
  },
  {
    "name": "Hapoel Be'er Sheva",
    "country": "Israel",
    "logo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-football-teams/Hapoel_Be_er_Sheva_Israel.png"
  },
  {
    "name": "Highlanders FC",
    "country": "Zimbabwe",
    "logo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-football-teams/Highlanders_FC_Zimbabwe.png"
  },
  {
    "name": "Hittarps IK",
    "country": "Sweden",
    "logo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-football-teams/Hittarps_IK_Sweden.png"
  },
  {
    "name": "Land Home NTUS",
    "country": "Taiwan",
    "logo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-football-teams/Land_Home_NTUS_Taiwan.png"
  },
  {
    "country": "USA",
    "name": "Houston Dynamo",
    "logo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-football-teams/Houston_Dynamo_USA.png"
  },
  {
    "name": "Hualien",
    "country": "Taiwan",
    "logo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-football-teams/Hualien_Taiwan.png"
  },
  {
    "name": "Independiente del Valle",
    "country": "Ecuador",
    "logo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-football-teams/Independiente_del_Valle_Ecuador.png"
  },
  {
    "name": "Jamshedpur FC",
    "country": "India",
    "logo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-football-teams/Jamshedpur_FC_India.png"
  },
  {
    "name": "Juventus",
    "country": "Italy",
    "logo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-football-teams/Juventus_Italy.png"
  },
  {
    "name": "KAA Ghent",
    "country": "Belgium",
    "logo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-football-teams/KAA_Ghent_Belgium.png"
  },
  {
    "name": "Kaohsiung Sunny Bank",
    "country": "Taiwan",
    "logo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-football-teams/Kaohsiung_Yangxin_Taiwan.png"
  },
  {
    "name": "Kariobangi Sharks FC",
    "country": "Kenya",
    "logo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-football-teams/Kariobangi_Sharks_FC_Kenya.png"
  },
  {
    "name": "Kerala Blasters FC",
    "country": "India",
    "logo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-football-teams/Kerala_Blasters_FC_India.png"
  },
  {
    "name": "LASK",
    "country": "Austria",
    "logo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-football-teams/LASK_Austria.png"
  },
  {
    "name": "La Fiorita",
    "country": "San Marino",
    "logo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-football-teams/La_Fiorita_San_Marino.png"
  },
  {
    "name": "Lazio",
    "country": "Italy",
    "logo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-football-teams/Lazio_Italy.png"
  },
  {
    "name": "Lincoln Red Imps",
    "country": "Gibraltar",
    "logo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-football-teams/Lincoln_Red_Imps_Gibraltar.png"
  },
  {
    "name": "Linfield",
    "country": "Northern Ireland",
    "logo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-football-teams/Linfield_Northern_Ireland.png"
  },
  {
    "name": "Liverpool",
    "country": "England",
    "logo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-football-teams/Liverpool_England.png"
  },
  {
    "country": "Scotland",
    "name": "Livingston FC",
    "logo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-football-teams/Livingston_FC_Scotland.png"
  },
  {
    "name": "Lokomotiv Moscow",
    "country": "Russia",
    "logo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-football-teams/Lokomotiv_Moscow_Russia.png"
  },
  {
    "name": "Ludogorets Razgard",
    "country": "Bulgaria",
    "logo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-football-teams/Ludogorets_Razgrad_Bulgaria.png"
  },
  {
    "name": "MKS Cracovia",
    "country": "Poland",
    "logo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-football-teams/MKS_Cracovia_Poland.png"
  },
  {
    "name": "Malmö FF",
    "country": "Sweden",
    "logo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-football-teams/Malmo%CC%88_FF_Sweden.png"
  },
  {
    "name": "Marseille",
    "country": "France",
    "logo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-football-teams/Marseille_France.png"
  },
  {
    "name": "Ming Chuan University",
    "country": "Taiwan",
    "logo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-football-teams/Ming_Chuan_University_Taiwan.png"
  },
  {
    "country": "Japan",
    "name": "Montedio Yamagata",
    "logo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-football-teams/Montedio_Yamagata_Japan.png"
  },
  {
    "country": "USA",
    "name": "NYC FC",
    "logo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-football-teams/NYC_FC_USA.png"
  },
  {
    "country": "USA",
    "name": "New England Revolution",
    "logo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-football-teams/New_England_Revolution_USA.png"
  },
  {
    "country": "USA",
    "name": "New York Red Bulls",
    "logo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-football-teams/New_York_Red_Bulls_USA.png"
  },
  {
    "name": "OFK Titograd",
    "country": "Montenegro",
    "logo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-football-teams/OFK_Titograd_Montenegro.png"
  },
  {
    "name": "Olympiakos",
    "country": "Greece",
    "logo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-football-teams/Olympiakos_Greece.png"
  },
  {
    "name": "Olympique Lyonnais",
    "country": "France",
    "logo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-football-teams/Olympique_Lyonnais_France.png"
  },
  {
    "name": "Omonia",
    "country": "Cyprus",
    "logo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-football-teams/Omonia_Cyprus.png"
  },
  {
    "name": "PAOK Salonika",
    "country": "Greece",
    "logo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-football-teams/PAOK_Salonika_Greece.png"
  },
  {
    "name": "Panathinaikos",
    "country": "Greece",
    "logo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-football-teams/Panathinaikos_Greece.png"
  },
  {
    "country": "Scotland",
    "name": "Partick Thistle",
    "logo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-football-teams/Partick_Thistle_Scotland.png"
  },
  {
    "name": "Raja Permin FC",
    "country": "Malaysia",
    "logo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-football-teams/Raja_Permin_FC_Malaysia.png"
  },
  {
    "name": "Rangers",
    "country": "Scotland",
    "logo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-football-teams/Rangers_Scotland.png"
  },
  {
    "name": "Taipei Red Lion FC",
    "country": "Taiwan",
    "logo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-football-teams/Red_Lion_FC_Taiwan.png"
  },
  {
    "name": "Rosenborg",
    "country": "Norway",
    "logo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-football-teams/Rosenborg_Norway.png"
  },
  {
    "name": "SC Villa",
    "country": "Uganda",
    "logo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-football-teams/SC_Villa_Uganda.png"
  },
  {
    "name": "SJK Seinajoki",
    "country": "Finland",
    "logo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-football-teams/SJK_Seinajoki_Finland.png"
  },
  {
    "name": "Saint Anthony's FC",
    "country": "Scotland",
    "logo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-football-teams/Saint_Anthony_s_FC_Scotland.png"
  },
  {
    "name": "Sakaryaspor",
    "country": "Turkey",
    "logo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-football-teams/Sakaryaspor_Turkey.png"
  },
  {
    "country": "USA",
    "name": "San Jose Earthquakes",
    "logo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-football-teams/San_Jose_Earthquakes_USA.png"
  },
  {
    "name": "Santos",
    "country": "Brazil",
    "logo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-football-teams/Santos_Brazil.png"
  },
  {
    "name": "Schalke 04",
    "country": "Germany",
    "logo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-football-teams/Schalke_04_Germany.png"
  },
  {
    "name": "Sekondi Hasaacas FC",
    "country": "Ghana",
    "logo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-football-teams/Sekondi_Hasaacas_FC_Ghana.png"
  },
  {
    "name": "Sevilla",
    "country": "Spain",
    "logo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-football-teams/Sevilla_Spain.png"
  },
  {
    "name": "Shamrock Rovers FC",
    "country": "Ireland",
    "logo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-football-teams/Shamrock_Rovers_FC_Ireland.png"
  },
  {
    "name": "Slavia Prague",
    "country": "Czech Republic",
    "logo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-football-teams/Slavia_Prague_Czech_Republic.png"
  },
  {
    "name": "Slovan Bratislava",
    "country": "Slovakia",
    "logo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-football-teams/Slovan_Bratislava_Slovakia.png"
  },
  {
    "name": "Spartak Moscow",
    "country": "Russia",
    "logo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-football-teams/Spartak_Moscow_Russia.png"
  },
  {
    "name": "Sport Club Internacional",
    "country": "Brazil",
    "logo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-football-teams/Sport_Club_Internacional_Brazil.png"
  },
  {
    "country": "Scotland",
    "name": "St. Johnstone",
    "logo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-football-teams/St._Johnstone_Scotland.png"
  },
  {
    "name": "Sunderland AFC",
    "country": "England",
    "logo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-football-teams/Sunderland_AFC_England.png"
  },
  {
    "name": "Sunshine Stars FC",
    "country": "Nigeria",
    "logo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-football-teams/Sunshine_Stars_FC_Nigeria.png"
  },
  {
    "name": "Sutjeska Niksic",
    "country": "Montenegro",
    "logo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-football-teams/Sutjeska_Niksic_Montenegro.png"
  },
  {
    "name": "Sydney FC",
    "country": "Australia",
    "logo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-football-teams/Sydney_FC_Australia.png"
  },
  {
    "name": "Taichung Blue Whale",
    "country": "Taiwan",
    "logo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-football-teams/Taichung_Blue_Whale_Taiwan.png"
  },
  {
    "name": "Taichung FUTURO",
    "country": "Taiwan",
    "logo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-football-teams/Taichung_FUTURO_Taiwan.png"
  },
  {
    "name": "Taiwan Steel Group FC",
    "country": "Taiwan",
    "logo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-football-teams/Tainan_Steel_Taiwan_Taiwan.png"
  },
  {
    "name": "Taipei Bravo!",
    "country": "Taiwan",
    "logo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-football-teams/Taipei_Bear_Taiwan.png"
  },
  {
    "name": "Inter Taoyuan FC",
    "country": "Taiwan",
    "logo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-football-teams/Taoyuan_International_Taiwan.png"
  },
  {
    "name": "The Strongest",
    "country": "Bolivia",
    "logo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-football-teams/The_Strongest_Bolivia.png"
  },
  {
    "name": "Toronto FC",
    "country": "Canada",
    "logo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-football-teams/Toronto_FC_Canada.png"
  },
  {
    "name": "Tottenham Hotspur",
    "country": "England",
    "logo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-football-teams/Tottenham_Hotspur_England.png"
  },
  {
    "name": "Valencia",
    "country": "Spain",
    "logo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-football-teams/Valencia_Spain.png"
  },
  {
    "name": "Vancouver Whitecaps FC",
    "country": "Canada",
    "logo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-football-teams/Vancouver_Whitecaps_FC_Canada.png"
  },
  {
    "name": "Vasco da Gama",
    "country": "Brazil",
    "logo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-football-teams/Vasco_da_Gama_Brazil.png"
  },
  {
    "name": "VfL Wolfsburg",
    "country": "Germany",
    "logo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-football-teams/VfL_Wolfsburg_Germany.png"
  },
  {
    "name": "Viktoria Plzen",
    "country": "Czech Republic",
    "logo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-football-teams/Viktoria_Plzen_Czech_Republic.png"
  },
  {
    "name": "WSG Tirol",
    "country": "Austria",
    "logo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-football-teams/WSG_Tirol_Austria.png"
  },
  {
    "name": "Watford",
    "country": "England",
    "logo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-football-teams/Watford_England.png"
  },
  {
    "name": "Wellington Phoenix",
    "country": "New Zealand",
    "logo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-football-teams/Wellington_Phoenix_New_Zealand.png"
  },
  {
    "name": "West Ham United",
    "country": "England",
    "logo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-football-teams/West_Ham_United_England.png"
  },
  {
    "name": "Western Sydney Wanderers FC",
    "country": "Australia",
    "logo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-football-teams/Western_Sydney_Wanderers_FC_Australia.png"
  },
  {
    "name": "Wolves",
    "country": "England",
    "logo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-football-teams/Wolves_England.png"
  },
  {
    "name": "Young Boys",
    "country": "Switzerland",
    "logo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-football-teams/Young_Boys_Switzerland.png"
  },
  {
    "name": "Zimbru Chisinau",
    "country": "Moldova",
    "logo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-football-teams/Zimbru_Chisinau_Moldova.png"
  },
  {
    "country": "England",
    "name": "Manchester United",
    "logo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-football-teams/Manchester_United_England.png"
  },
  {
    "country": "Spain",
    "name": "Real Madrid",
    "logo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-football-teams/Real_Madrid_Spain.png"
  },
  {
    "country": "France",
    "name": "PSG",
    "logo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-football-teams/PSG_France.png"
  },
  {
    "country": "Canada",
    "name": "Atlético Ottawa",
    "logo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-football-teams/Atletico_Ottawa.png"
  },
  {
    "country": "England",
    "name": "Burnley FC",
    "logo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-football-teams/Burnley_FC.png"
  },
  {
    "country": "Canada",
    "name": "Cavalry FC",
    "logo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-football-teams/Cavalry_FC.png"
  },
  {
    "country": "Canada",
    "name": "FC Edmonton",
    "logo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-football-teams/FC_Edmonton.png"
  },
  {
    "country": "Brazil",
    "name": "Flamengo",
    "logo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-football-teams/Flamengo.png"
  },
  {
    "country": "Canada",
    "name": "Forge FC",
    "logo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-football-teams/Forge_FC.png"
  },
  {
    "country": "Canada",
    "name": "HFX Wanderers",
    "logo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-football-teams/HFX_Wanderers.png"
  },
  {
    "country": "Canada",
    "name": "Pacific FC",
    "logo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-football-teams/Pacific_FC.png"
  },
  {
    "country": "Brazil",
    "name": "Palmeiras",
    "logo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-football-teams/Palmeiras.png"
  },
  {
    "country": "Brazil",
    "name": "Paysandu",
    "logo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-football-teams/Paysandu.png"
  },
  {
    "country": "Canada",
    "name": "Valour FC",
    "logo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-football-teams/Valour_FC.png"
  },
  {
    "country": "Canada",
    "name": "York9 FC ",
    "logo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-football-teams/York9_FC.png"
  },
  {
    "country": "Italy",
    "name": "Bologna",
    "logo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-football-teams/Bologna.png"
  },
  {
    "country": "Italy",
    "name": "Parma",
    "logo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-football-teams/Parma.png"
  },
  {
    "country": "Italy",
    "name": "Pescara",
    "logo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-football-teams/Pescara.png"
  },
  {
    "country": "Italy",
    "name": "Sampdoria",
    "logo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-football-teams/Sampdoria.png"
  },
  {
    "country": "England",
    "name": "Manchester City",
    "logo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-football-teams/Manchester_City.png"
  },
  {
    "country": "Turkey",
    "name": "Galatasaray",
    "logo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-football-teams/Galatasaray.png"
  },
  {
    "country": "Austria",
    "name": "SK Rapid Wien",
    "logo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-football-teams/SK_Rapid_Wien.png"
  },
  {
    "country": "France",
    "name": "Bordeaux",
    "logo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-football-teams/Bordeaux.png"
  },
  {
    "country": "Brazil",
    "name": "Athletico Paranaense",
    "logo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-football-teams/Athletico_Paranaense.png"
  },
  {
    "country": "Brazil",
    "name": "Bahia Futebol Clube",
    "logo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-football-teams/Bahia_Futebol_Clube.png"
  },
  {
    "country": "Brazil",
    "name": "Clube Náutico Capibaribe",
    "logo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-football-teams/Clube_Nautico_Capibaribe.png"
  },
  {
    "country": "Brazil",
    "name": "Corinthians",
    "logo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-football-teams/Corinthians.png"
  },
  {
    "country": "Brazil",
    "name": "Fortaleza Esporte Clube",
    "logo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-football-teams/Fortaleza_Esporte_Clube.png"
  },
  {
    "country": "Brazil",
    "name": "Parana",
    "logo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-football-teams/Parana.png"
  },
  {
    "country": "Argentina",
    "name": "Argentine Football Association",
    "logo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-football-teams/AFA.png"
  },
  {
    "country": "Poland",
    "name": "Arka Gdynia",
    "logo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-football-teams/Arka_Gdynia.png"
  },
  {
    "country": "Poland",
    "name": "GKS Piast Gliwice",
    "logo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-football-teams/GKS_Piast_Gliwice.png"
  },
  {
    "country": "Poland",
    "name": "Górnik Zabrze",
    "logo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-football-teams/Gornik_Zabrze.png"
  },
  {
    "country": "Poland",
    "name": "Jagiellonia Białystok",
    "logo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-football-teams/Jagiellonia_Bialystok.png"
  },
  {
    "country": "Poland",
    "name": "Korona Kielce",
    "logo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-football-teams/Korona_Kielce.png"
  },
  {
    "country": "Poland",
    "name": "Lech Poznań",
    "logo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-football-teams/Lech_Poznan.png"
  },
  {
    "country": "Poland",
    "name": "MKS Pogoń Szczecin",
    "logo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-football-teams/MKS_Pogon_Szczecin.png"
  },
  {
    "country": "Poland",
    "name": "RKS Raków Częstochowa",
    "logo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-football-teams/RKS_Rakow_Czestochowa.png"
  },
  {
    "country": "Poland",
    "name": "WKS-Śląsk Wrocław",
    "logo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-football-teams/WKS_Slask_Wroclaw.png"
  },
  {
    "country": "Poland",
    "name": "Zagłębie Lubin",
    "logo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-football-teams/Zaglebie_Lubin.png"
  },
  {
    "country": "Italy",
    "name": "Genoa",
    "logo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-football-teams/Genoa.png"
  },
  {
    "country": "Italy",
    "name": "Sassuolo",
    "logo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-football-teams/Sassuolo.png"
  },
  {
    "country": "Scotland",
    "name": "Airdrieonians FC",
    "logo": "https://gmcngine-football-care.s3.us-east-2.amazonaws.com/partners-football-teams/Airdrieonians_FC.png"
  }
]


// WEBPACK FOOTER //
// ./src/modules/Dashboard/Partners/data/clubs.ts